import React from 'react';

export const MainTimer = ({time}) => (
    <div className="container">
        <p className="text-center display-1 my-4">
            {time}
        </p>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/MainTimer.jsx